import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import CityForm from '../components/CityForm';
import { useCreateCity } from '../hooks/useCityMutations';
import type { CityFormData } from '@/shared/types';

export default function CityCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const mutation = useCreateCity();

  const handleSubmit = (data: CityFormData) => {
    mutation.mutate(data, { onSuccess: () => navigate('/cities') });
  };

  return (
    <div>
      <PageHeader back title={t('cities.addNew')} />
      <Card style={{ marginTop: 16 }}>
        <CityForm onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
